import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { ErrorScreen, StudentSettings } from '@screens';
import { activityUserIdAtom, currentUserIdAtom } from '@store';

import { NavigateToCurrentActivity } from '../components/NavigateToCurrentActivity/NavigateToCurrentActivity';
import { LINKS } from '../utils/routes';

export const StudentSettingsScreen = () => {
    const activeUserId = useAtomValue(activityUserIdAtom);
    const currentUserId = useAtomValue(currentUserIdAtom);
    const navigate = useNavigate();

    if (!activeUserId || activeUserId === currentUserId)
        return <ErrorScreen message="No student selected" action={<NavigateToCurrentActivity />} />;
    return <StudentSettings onClose={() => navigate(LINKS.getFullActivity())} />;
};
